module.exports = __webpack_public_path__ + "static/media/menu-icon-discovery-locked.7c245454.png";